mutation UpdatePoll($id: ID!, $input: UpdatePollInput!) {
  updatePoll(id: $id, input: $input) {
    id
    question
    options {
      id
      text
      isCorrect
    }
    isMultiple
    resultsMode
    usage {
      attachmentsCount
      isLocked
    }
    updatedAt
  }
}
